
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import AppPagination from "../../app/components/AppPagination";
import CategoryMenu from "../../app/components/CategoryMenu";
import FilterSelectList from "../../app/components/FilterSelectList";
import useProducts from "../../app/hooks/useProducts";

import LoadingComponent from "../../app/layout/LoadingComponent";
import { useAppDispatch } from "../../app/store/configureStore";
import { validationSchema } from "../admin/productValidation";
import { setPageNumber } from "./catalogSlice";
import ProductList from "./ProductList"

const sortOptions = [
    {value: 'name', label: 'Alphabetical'},
    {value: 'priceDesc', label: 'Price - High to low'},
    {value: 'price', label: 'Price - Low to High'},
]


export default function Catalog() {
  // const {control} = useForm()
  const { control } = useForm({
    resolver: yupResolver(validationSchema)
});
  const { products, filtersLoaded,  metaData} = useProducts()
 
  const dispatch = useAppDispatch()
  

  if (!filtersLoaded) return <LoadingComponent message="Loading products"/>

  return (
    <>
    <div style={{width: '30%', alignContent: 'center'}}>
        
    </div>
    <Grid container columnSpacing={4} justifyContent="center" alignItems="center">
       
        <Grid item xs={6} mb={2}>
            <FilterSelectList control={control} name='filter' label='Order by' items={sortOptions} />
        </Grid>
        <Grid item xs={6} mb={2}>
            <CategoryMenu />   
        </Grid>
        

        <Grid item xs={12}>
            <ProductList products={products} />
        </Grid>
        <Grid item xs={3} />
        <Grid item xs={12} mb={2} mt={2}>
              {metaData &&
             <AppPagination 
                metaData={metaData}
                onPageChange={(page: number) => dispatch(setPageNumber({pageNumber: page}))}
             />
              }
        </Grid>
                      
        
          
    </Grid>
    </>
  )
}